export const VisaBulletinTrendChartLegend: React.FC = () => {
  return (
    <div className="mt-6 flex items-center gap-4">
      <LegendItem color="bg-[hsla(21,90%,48%,1)]" label="Final Action Date" />
      <LegendItem color="bg-[hsla(224,64%,33%,1)]" label="Date for Filing" />
    </div>
  )
}

const LegendItem: React.FC<{ color: string; label: string }> = ({ color, label }) => (
  <div className="flex items-center gap-2">
    <div className={`h-[10px] w-[10px] rounded-full ${color}`} />
    <span className="text-xs text-[hsla(0,0%,47%,1)]">{label}</span>
  </div>
)
